import React from 'react';

export const LazyReportViewer = React.lazy(() =>
  import('./ReportViewer').then((module) => ({
    default: module.ReportViewer,
  }))
);
